import { INotificationBase } from '../../models/notifications';
import IListResponse from '../../utils/list-response';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IListNotificationsProps {
  isUnread?: boolean;
  limit?: number;
  page?: number;
}

export const listNotifications = async ({
  isUnread,
  limit,
  page,
}: IListNotificationsProps): Promise<IListResponse<INotificationBase>> => {
  const { data } = await jhsfBookingsApi.get<IListResponse<INotificationBase>>(
    '/notifications',
    {
      params: { isUnread, limit, page },
    },
  );

  return data;
};
